import React, { Component } from "react";
import {
  getTabForms,
  updateTab,
  getTabs,
  removeTab,
} from "../../../services/formService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../../config';
import { logActivity } from '../../../services/utilService';
import { getFormWidgetQuestionsAnswers } from '../../../services/formService';
import { QuestionTypes } from '../../../constants/QuestionTypes';
import { stripTags } from '../../common/commonFuncs';
// import TabDependencies from "./Widget_TabDependencies";

class WTab extends Component {
  form_options = [];
 

  constructor(props) {
    super(props);

  
    this.state = {
      Tabs: [],
      showTabDependencies: true,
      loading: true
      // Widget information in props.Widget
    };
  
  }

  async componentDidMount() {
    const {Project_ID} = this.props;
    this.setState({ loading: true });
    const { data: forms } = await getTabForms(Project_ID);
  
    this.form_options = forms.filter((f) => f.Form_ID !== this.props.Form_ID);

    (getTabs(this.props.Widget.Widget_ID)).
      then((data) => {
        let Tabs = data.data;
        Tabs.map(async (Tab, tIdx) => {
          Tab['Tab_DependentTabs'] = Tab['Tab_DependentTabs'] ? JSON.parse(Tab['Tab_DependentTabs']) : [];
        });
        this.setState({ Tabs, loading: false });
        return Tabs;
      }).
      then((Tabs)=>{
        Tabs.map(async (Tab, tIdx) => {
          Tab['key'] = tIdx;
          Tab['label'] = Tab.Tab_Name;
          

          let formId = Tab['Tab_Form_ID'],
              widgetsQA = await getFormWidgetQuestionsAnswers(formId).then((response) => response.data),
              otherQuestionTypes = [QuestionTypes.Checkbox, QuestionTypes.Date, QuestionTypes.Numeric, QuestionTypes.Text, QuestionTypes.Textarea, QuestionTypes.Time];
          if (widgetsQA.length > 0) {
            let uniqueFormQuestions = [
              ...new Map(widgetsQA.filter((w) => w.Question_Type_ID === QuestionTypes.Multiple_Choice).map((item) => [item['Question_ID'], item])).values(),
            ],
              questionAnswers = [];
            if (uniqueFormQuestions.length > 0) {
              uniqueFormQuestions.forEach(
                (q) => {
                  let tempQA = widgetsQA.filter((w) => w['Question_ID'] === q['Question_ID']);
                  questionAnswers.push(tempQA.map(
                    (a) => {
                      return {
                        'key': a.Answer_ID,
                        'label': stripTags(a.Answer_Text) || '',
                        'Question_ID': a.Question_ID,
                        'Answer_ID': a.Answer_ID,
                        'Answer_Text': a.Answer_Text,
                        'Answer_Number': a.Answer_Number,

                      };
                    }));
                });
              Tab['formQuestions'] = uniqueFormQuestions;
              Tab['formMultipleChoiceQuestions'] = uniqueFormQuestions;
              Tab['formQuestionAnswers'] = questionAnswers;
              Tab['dependentQuestions'] = [];
            }
            Tab['hasQA'] = uniqueFormQuestions.length > 0;

            /*Other Question Types*/
            let otherFormQuestions = [
              ...new Map(widgetsQA.filter((w) => otherQuestionTypes.includes(w.Question_Type_ID)).map((item) => [item['Question_ID'], item])).values(),
            ]
            Tab['formQuestions'] = [...Tab['formQuestions'],...otherFormQuestions];
          }
          else {
            Tab['hasQA'] = false;
          }
          return Tab;
        })
        this.setState({ Tabs });
      })
  }

  handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const Tabs = [...this.state.Tabs];
    Tabs[index][name] = value;
    if (name.includes('Tab_Name')) {
      Tabs[index]['key'] = index;
      Tabs[index]['label'] = value;
    }
    this.setState({ Tabs });
  };

  handleSelectChange = (value, index) => {
    console.log(index, value, this.state.Tabs[index]);
    const Tabs = [...this.state.Tabs];
    Tabs[index]['Tab_DependentTabs'] = (value !== null ? [...Tabs[index]['Tab_DependentTabs'], value.value] : []);
    this.setState({ Tabs });
  }

  handleSingleRemove = async (index) => {
    const tab = this.state.Tabs[index];

    const { data } = await removeTab(this.props.Widget.Widget_ID, tab.Tab_ID);
    if (data.includes("Success")) {
      const Tabs = [...this.state.Tabs];
      Tabs.splice(index, 1);
      this.setState({ Tabs });
      toaster('success', 'Tab removed');
      logActivity('/formBuilder','WIDGET_TAB_DELETE_SUCCESS');
    } else {
      toaster('error', data);
      logActivity('/formBuilder','WIDGET_TAB_DELETE_FAILED');
    }
  };

  handleAdd = () => {
    const idx = -(this.state.Tabs.length + 1);
    const Tabs = [
      ...this.state.Tabs,
      { Tab_ID: idx, Tab_Name: "", Tab_Form_ID: "", Tab_DependentTabs: [], key: idx, label: '', Locking_StoredProcedure: ""},
    ];
    this.setState({ Tabs });
  };

  handleSave =async ()=> {
    const { Widget_ID } = this.props.Widget;
    const { data } = await updateTab(Widget_ID, this.state.Tabs);
    toaster('success', data);
    logActivity('/formBuilder','WIDGET_TAB_SAVE_SUCCESS');
  }

  handleRemove =() =>{
    this.props.onRemove(this.props.Widget.Widget_ID);
  }

  render() {
    let { Tabs } = this.state;
    return (
      <React.Fragment>
        <div>
          <div className="form-row ml-1">
            <div className="form-group col-md-5">
              <label>Name</label>
            </div>
            <div className="form-group col-md-3">
            <label>Associated Form</label>
            </div>
            <div className="form-group col-md-3 text-center">
            <label>Locking Stored Procedure</label>
            </div>
          </div>
        </div>
        <div className="text-center">
          {Tabs.map((row, idx) => {
            return (
              <div className="form-row" key={idx}>
                <div className="form-group col-md-5">
                  <input
                    className="form-control"
                    name="Tab_Name"
                    placeholder="Enter Tab Name"
                    value={row.Tab_Name}
                    onChange={(e) => this.handleInputChange(e, idx)}
                  />
                </div>

                <div className="form-group col-md-3">
                  <select
                    className="custom-select"
                    value={row.Tab_Form_ID}
                    name="Tab_Form_ID"
                    onChange={(e) => this.handleInputChange(e, idx)}
                  >
                    <option>Select Form</option>
                    {this.form_options.map((form) => {
                      return (
                        <option key={form.Form_ID} value={form.Form_ID}>
                          {form.Form_Name}
                        </option>
                      );
                    })}
                  </select>
                </div>  
                {/* <TabDependencies key={Tabs} idx={idx} Tabs={Tabs} currentOpenTab={row}/> */}
                <div className='form-group col-md-3'>
                  <input
                      className="form-control"
                      name="Locking_StoredProcedure"
                      value={row.Locking_StoredProcedure}
                      onChange={(e) => this.handleInputChange(e, idx)}
                  />
                </div>


                {Tabs.length !== 1 && (
                  <div className="form-group col-md-1">
                    <button
                      className="btn btn-outline-warning btn-sm"
                      onClick={() => this.handleSingleRemove(idx)}
                    >
                      Remove
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <br />
        <div className="text-center">
          <button
            className="btn btn-outline-success btn-sm"
            onClick={this.handleAdd}
          >
            <FontAwesomeIcon icon={faPlus} />
          </button>
        </div>

        <div className="float-right">
          <button
            className="btn btn-outline-primary m-2"
            onClick={this.handleSave}
          >
            Save
          </button>
          <button
            className="btn btn-outline-danger"
            onClick={this.handleRemove}
          >
            Delete
          </button>
        </div>
        <ToastContainer/>
      </React.Fragment>
    );
  }
}

export default WTab;
